import { AppBar, Toolbar, Typography, IconButton, Badge } from "@material-ui/core"
import { useState } from "react"
import { Menu, LogoIonic, LogoNpm, LogoGithub, LogoTwitter } from 'react-ionicons'
import SideBarMenu from "./SideBarMenu"
import { IconsHeaderContainer } from './styles'
const Header = () => {

  const [showSideBar, setShowSideBar] = useState(false)

  return (
    <>
      <SideBarMenu show={showSideBar} onClose={() => setShowSideBar(false)} />
      <AppBar position="sticky" color="inherit">
        <Toolbar>
          <Typography variant="h6" style={{flexGrow: '1'}}>
            <IconButton onClick={() => setShowSideBar(true)}>
              <Menu style={{verticalAlign: 'middle'}} />
            </IconButton>
            <LogoIonic color="rgb(44, 118, 249)" rotate height="30px" width="30px" style={{verticalAlign: 'middle', marginRight: '5px'}} />
            <Badge badgeContent={<span style={{color: 'rgb(44, 118, 249)'}}>4.2.0</span>}>react-ionicons</Badge>
          </Typography>
          <IconsHeaderContainer>
            <IconButton onClick={() => window.open('https://www.npmjs.com/package/react-ionicons')}>
              <LogoNpm style={{verticalAlign: 'middle'}} height="30px" width="30px" color="rgb(206, 0, 17)" />
            </IconButton>
            <IconButton style={{verticalAlign: 'middle'}} onClick={() => window.open('https://github.com/zamarrowski/react-ionicons')}>
              <LogoGithub />
            </IconButton>
            <IconButton style={{verticalAlign: 'middle'}} onClick={() => window.open('https://twitter.com/zamarrowski')}>
              <LogoTwitter color="rgb(0, 152, 235)" />
            </IconButton>
          </IconsHeaderContainer>
        </Toolbar>
      </AppBar>
    </>
  )
}

export default Header